import { AppRoutes } from "../../lib/common/AppRoutes";

export default function Patents() {
  return (
    <div className="prose">
      <h1 className="hero__title">{AppRoutes.PATENTS.title}</h1>
      <p>
        Coming Soon.
      </p>
    </div>
  );
}
